import { render } from "./Dept.vue?vue&type=template&id=cdd1b9ea&scoped=true"
import script from "./Dept.vue?vue&type=script&lang=js"
export * from "./Dept.vue?vue&type=script&lang=js"

import "./Dept.vue?vue&type=style&index=0&id=cdd1b9ea&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cdd1b9ea"

export default script